import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import { FC, useEffect, useMemo } from 'react'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { useWrapperStore } from '../../store/storeWrapper'

type Props = {
    id?: string
    handleChange: (name: string, value?: string) => void
}

export const ProjectSelect: FC<Props> = ({ id, handleChange }) => {
    const [_, setCurrentProjectId] = useLocalStorage('currentProjectId', null)
    const { projectListActive } = useWrapperStore((state) => state)

    useEffect(() => {
        if (id) {
            setCurrentProjectId(id)
        }
    }, [id])

    const options = useMemo(
        () => [
            {
                key: 'empty-project-option',
                value: '',
                title: 'Без проекта',
            },
            ...(projectListActive?.map(({ id, title }) => ({ key: id, value: id, title })) ?? []),
        ],
        [projectListActive],
    )

    const handleChangeValue = (event: SelectChangeEvent<unknown>) => {
        const {
            target: { name, value },
        } = event

        handleChange(name, `${value}` || undefined)
    }

    return (
        <Select
            MenuProps={{
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                },
            }}
            id="workplaceId"
            name="workplaceId"
            variant="outlined"
            value={id ?? ''}
            displayEmpty
            onChange={handleChangeValue}
            sx={{
                width: '100%',
                maxHeight: '40px',
                '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 36px 8px 16px !important',
                },
                '& .MuiSelect-icon': {
                    marginRight: '8px',
                    fontSize: ' 20px',
                    color: '#5A5F72',
                },
            }}>
            {map(options, (item) => {
                const { title, key, value } = item
                return (
                    <MenuItem
                        value={value}
                        key={key}
                        sx={{
                            borderBottom: '1px solid #F4F4F6',
                            p: '10px 16px',
                        }}>
                        <Typography
                            sx={{
                                maxWidth: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                color: '#181B25',
                            }}
                            variant="body2">
                            {title}
                        </Typography>
                    </MenuItem>
                )
            })}
        </Select>
    )
}
